import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { ReactNode } from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils/cn';
import { useUserMenuClose } from './context';

interface UserMenuItemProps {
  icon: IconDefinition;
  label: string;
  onClick: () => void;
  /** Log out and the like: red label, and the icon drops its muted tint. */
  destructive?: boolean;
  /** Trailing slot — the unread dot on notifications, for instance. */
  trailing?: ReactNode;
  /** Keeps the menu open after the click. Default is to dismiss it. */
  keepOpen?: boolean;
  className?: string;
}

export function UserMenuItem({
  icon,
  label,
  onClick,
  destructive = false,
  trailing,
  keepOpen = false,
  className,
}: UserMenuItemProps) {
  const close = useUserMenuClose();

  return (
    <Button
      variant='ghost'
      className={cn(
        'w-full justify-start gap-2.5 px-3 h-8 text-sm font-normal',
        destructive && 'text-destructive hover:text-destructive',
        trailing && 'relative',
        className,
      )}
      onClick={() => {
        onClick();
        if (!keepOpen) close();
      }}
    >
      <FontAwesomeIcon
        icon={icon}
        className={cn(
          'size-3 shrink-0',
          !destructive && 'text-muted-foreground',
        )}
      />
      {label}
      {trailing}
    </Button>
  );
}
